

















 import { Component, Vue, Prop } from 'vue-property-decorator';
 import { percentFilter } from '@/filters/percent';
 import { formattedDate } from '@/filters/date';
 import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
 import { VBTooltip } from 'bootstrap-vue';

@Component({
  name: 'LastImageInfo',
  components: {
    AgroIcon: AgroIcons,
  },
  filters: {
    percentFilter,
    formattedDate,
  },
  directives: {
    BTooltip: VBTooltip,
  },
})
export default class LastImageInfo extends Vue {
  @Prop({type: Boolean, default: false})
  private isEnhanced!: boolean;

  @Prop(Date)
  private lastImageDate!: Date;

  @Prop(Number)
  private visiblePercentage!: number;

}
